import type { LabJob } from "./api";

export type LabProviderIdentity = {
  originalProviderId: string;
  concreteProviderId: "kling_piapi" | "kling_direct" | null;
  label: string;
  provenance: "recorded" | "legacy-derived" | "legacy-unknown";
};

export const concreteKlingProviderLabel = (
  providerId: "kling_piapi" | "kling_direct",
) => (providerId === "kling_piapi" ? "Kling via PiAPI" : "Kling Direct");

const concreteProvider = (value: unknown) =>
  value === "kling_piapi" || value === "kling_direct" ? value : null;

export function resolveLabProviderIdentity(job: LabJob): LabProviderIdentity {
  const originalProviderId = job.request?.provider_id ?? job.provider_id;
  const recorded = concreteProvider(originalProviderId);
  if (recorded) {
    return {
      originalProviderId,
      concreteProviderId: recorded,
      label: concreteKlingProviderLabel(recorded),
      provenance: "recorded",
    };
  }

  if (
    originalProviderId === "kling" ||
    originalProviderId === "kling_selector"
  ) {
    const derived = concreteProvider(
      job.attempt?.concrete_provider_id ?? job.result?.concrete_provider_id,
    );
    if (derived) {
      return {
        originalProviderId,
        concreteProviderId: derived,
        label: `${concreteKlingProviderLabel(derived)} (legacy-derived)`,
        provenance: "legacy-derived",
      };
    }
    return {
      originalProviderId,
      concreteProviderId: null,
      label: "Kling (legacy route unknown)",
      provenance: "legacy-unknown",
    };
  }

  return {
    originalProviderId,
    concreteProviderId: null,
    label: originalProviderId,
    provenance: "recorded",
  };
}
